.wrapper {
    padding: 4rem;
    display: flex;
    min-height: 100vh;
    .col {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .spine {
        border-left: 1px solid black;
    }

    .title {
        margin-bottom: 1rem;
    }
    input {
        padding: 0.5rem;
        padding-left: 0;
        border: 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        transition: border-bottom 0.3s ease-in-out;
        margin-bottom: 0.25rem;
        &:focus {
            outline: none;
            border-bottom: 1px solid black;
        }
    }
    button {
        margin-top: 1rem;
        padding: 0.5rem;
        border: 0;
        background-color: black;
        color: white;
        cursor: pointer;
        transition: background-color 0.3s ease-in-out;
        &:hover {
            background-color: rgba(0, 0, 0, 0.8);
        }
    }

    .errorWrapper {
        height: 0;
        overflow: visible;
        transform: translateY(1rem);
        font-size: 0.8rem;
        color: #600;
    }
}

@media (max-width: 1024px) {
}

@media (max-width: 650px) {
    .wrapper {
        .spine {
            width: 0;
            border-right: 0;
        }
        .col:nth-child(3) {
            display: none;
        }
    }
}
